// lib/components/table/standard-table/components/dnd-row.tsx
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { jsx } from "@emotion/react/jsx-runtime";
var DndRow = ({
  rowData,
  children,
  onClick
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: rowData.id });
  return /* @__PURE__ */ jsx(
    "tr",
    {
      onClick: (e) => {
        if (onClick) onClick(e, rowData);
      },
      ...attributes,
      ...listeners,
      ref: setNodeRef,
      style: {
        transform: CSS.Transform.toString(transform),
        transition,
        cursor: onClick ? "pointer" : void 0
      },
      children
    }
  );
};

export {
  DndRow
};
